import { atomWithKey as atom } from "./atomWithKey";

export const privacyPolicyContentResponseAtom = atom<any>({
  key: "privacyPolicyContentResponseAtom",
  default: "",
});
